import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './pages/Register';
import ChangePassword from './pages/ChangePassword';
import BulkEmail from './pages/BulkEmail';

// Camp Pages
import CampCenter from './modules/Camp/pages/CampCenter';
import CampSelection from './modules/Camp/pages/CampSelection';
import CampLogin from './modules/Camp/pages/CampLogin';
import CampRegistration from './modules/Camp/pages/CampRegistration';

// Retreat Pages
import RetreatCenter from './modules/Retreat/pages/RetreatCenter';
import RetreatSelection from './modules/Retreat/pages/RetreatSelection';
import RetreatRegistration from './modules/Retreat/pages/RetreatRegistration';

// Class Pages
import ClassCenter from './modules/Class/pages/ClassCenter';
import ClassCategory from './modules/Class/pages/ClassCategory';
import ClassSelection from './modules/Class/pages/ClassSelection';
import EnrollStudent from './modules/Class/pages/EnrollStudent';
import OrderSummary from './modules/Class/pages/OrderSummary';
import Payment from './modules/Class/pages/Payment';
import ClassRegistration from './modules/Class/pages/ClassRegistration';

// Tiffin Pages
import TiffinCenter from './modules/Tiffin/pages/TiffinCenter';
import TiffinSelection from './modules/Tiffin/pages/TiffinSelection';
import TiffinRegistration from './modules/Tiffin/pages/TiffinRegistration';

function App() {
  const [userCountry, setUserCountry] = useState('USA');

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Navigation userCountry={userCountry} setUserCountry={setUserCountry} />
        
        <main className="flex-grow">
          <Routes>
            {/* Home */}
            <Route path="/" element={<Home />} />

            {/* Registration */}
            <Route path="/register" element={<Register />} />

            {/* Forgot Password */}
            <Route path="/forgot-change-password" element={<ChangePassword />} />

            {/* Bulk Email */}
            <Route path="/email" element={<BulkEmail />} />

            {/* Camp Routes */}
            <Route path="/camp/center" element={<CampCenter />} />
            <Route path="/camp/selection" element={<CampSelection />} />
            <Route path="/camp/login" element={<CampLogin />} />
            <Route path="/camp/registration" element={<ProtectedRoute><CampRegistration /></ProtectedRoute>} />

            {/* Retreat Routes */}
            <Route path="/retreat/center" element={<RetreatCenter />} />
            <Route path="/retreat/selection" element={<RetreatSelection />} />
            <Route path="/retreat/registration" element={<ProtectedRoute><RetreatRegistration /></ProtectedRoute>} />

            {/* Class Routes */}
            <Route path="/class/center" element={<ClassCenter />} />
            <Route path="/class/category" element={<ClassCategory />} />
            <Route path="/class/selection" element={<ClassSelection />} />
            <Route path="/class/enroll-student" element={<ProtectedRoute><EnrollStudent /></ProtectedRoute>} />
            <Route path="/class/order-summary" element={<ProtectedRoute><OrderSummary /></ProtectedRoute>} />
            <Route path="/class/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
            <Route path="/class/registration" element={<ProtectedRoute><ClassRegistration /></ProtectedRoute>} />

            {/* Tiffin Routes */}
            <Route path="/tiffin/center" element={<TiffinCenter />} />
            <Route path="/tiffin/selection" element={<TiffinSelection />} />
            <Route path="/tiffin/registration" element={<ProtectedRoute><TiffinRegistration /></ProtectedRoute>} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
